const viloyatlar = [
  {
    id: "1",
    name: "Aндижон",
    lat: "40.8154",
    lon: "72.2837",
    tumanlar: [
      { nomi: "Андижон шахри", lat: "40.767319", lon: "72.364461" },
      { nomi: "Андижон тумани", lat: "40.814196", lon: "72.464561" },
      { nomi: "Асака", lat: "40.667720", lon: "72.237619" },
      { nomi: "Балиқчи", lat: "40.855638", lon: "71.951236" },
      { nomi: "Булоқбоши", lat: "40.430", lon: "72.3759" },
      { nomi: "Бўстон", lat: "40.696825", lon: "71.893556" },
      { nomi: "Избосган", lat: "40.912185", lon: "72.261577" },
      { nomi: "Қўрғонтепа", lat: "40.730175", lon: "72.759496" }, 
      { nomi: "Марҳамат", lat: "40.522460", lon: "72.306502" },
      { nomi: "Олтинкўл", lat: "40.777208", lon: "72.195201" },
      { nomi: "Пахтаобод", lat: "40.967893", lon: "72.411201" },
      { nomi: "Шаҳрихон", lat: "40.692121", lon: "72.072769" },
      { nomi: "Улуғнор", lat: "40.789588", lon: "71.703445" },
      { nomi: "Жалақудуқ", lat: "40.733920", lon: "72.635528" },
      { nomi: "Хўжаобод", lat: "40.644870", lon: "72.589310" },
      { nomi: "Хонабод", lat: "40.797910", lon: "72.986437" },
    ],  },
  {
    id: "2",
    name: "Бухоро",
    lat: "39.7681",
    lon: "64.4556",
    tumanlar: [
      { nomi: "Бухоро", lat: "39.778717", lon: "64.439335" },
      { nomi: "Жондор", lat: "39.928717", lon: "63.668680" },
      { nomi: "Ғиждувон", lat: "40.480082", lon: "64.785483" },
      { nomi: "Когон", lat: "339.753143", lon: "64.582132" },
      { nomi: "Олот", lat: "39.251207", lon: "64.116768" },
      { nomi: "Пешку'", lat: "40.591524", lon: "63.394020" },
      { nomi: "Қоракўл", lat: "39.785142", lon: "63.166450" },
      { nomi: "Қоровулбозор", lat: "39.398799", lon: "64.772431" },
      { nomi: "Ромитан", lat: "39.962542", lon: "64.100069" },
      { nomi: "Шофиркон", lat: "40.455754", lon: "64.311011" },
      { nomi: "Когон", lat: "39.753143", lon: "64.582132" },
      { nomi: "Вобкент", lat: "39.980498", lon: "64.538833" },
    ],  },
  {
    id: "3",
    name: "Фарғона",
    lat: "40.3734",
    lon: "71.7978",
    tumanlar: [
      { nomi: "Фаргона", lat: "40.389448", lon: "71.783135" },
      { nomi: "Боғдод", lat: "40.495830", lon: "71.219648" },
      { nomi: "Бувайда", lat: "40.615228", lon: "71.140965" },
      { nomi: "Данғара", lat: "40.633106", lon: "70.865030" },
      { nomi: "Фурқат", lat: "40.3054", lon: "70.760313" },
      { nomi: "Марғилон", lat: "40.470773", lon: "71.730826" },
      { nomi: "Олтиариқ", lat: "40.463302", lon: "71.456543" },
      { nomi: "Қўқон", lat: "40.539151", lon: "70.940425" },
      { nomi: "Қўштепа", lat: "40.531330", lon: "71.612338" },
      { nomi: "Қува", lat: "40.523886", lon: "72.068835" },
      { nomi: "Қувасой", lat: "40.296393", lon: "71.982624" },
      { nomi: "Риштон", lat: "40.368501", lon: "71.201116" },
      { nomi: "Сўх", lat: "40.038723", lon: "71.066674" },
      { nomi: "Тошлоқ", lat: "40.513980", lon: "71.823200" },
      { nomi: "Учкўприк", lat: "40.523845", lon: "71.043660" },
      { nomi: "Ўзбекистон", lat: "40.348050", lon: "70.876124" },
      { nomi: "Йозёвон", lat: "40.3911", lon: "71.3835" },
      { nomi: "Бешариқ", lat: "40.646348", lon: "71.658763" },
    ],  },
  {
    id: "4",
    name: "Жиззах",
    lat: "40.1250",
    lon: "67.8808",
    tumanlar: [
      { nomi: "Жиззах", lat: "40.120302", lon: "67.828544" },
      { nomi: "Бахмал", lat: "39.750439", lon: "67.864647" },
      { nomi: "Фориш", lat: "40.649433", lon: "67.178460" },
      { nomi: "Ғаллаорол", lat: "40.056059", lon: "67.399859" },
      { nomi: "Мирзачўл", lat: "40.699033 ", lon: "68.093763" },
      { nomi: "Пахтакор", lat: "40.346586", lon: "68.033665" },
      { nomi: "Янгиобод", lat: "40.003196 ", lon: "68.766304" },
      { nomi: "Зафаробод", lat: "40.358751", lon: "67.796771" },
      { nomi: "Зарбдор", lat: "40.156499", lon: "68.175330" },
      { nomi: "Зомин", lat: "39.895395", lon: "68.341806" },
      { nomi: "Дўстлик", lat: "40.542550", lon: "68.048838" },
      { nomi: "Шароф Рашидов", lat: "40.010601", lon: "67.881491" },
    ],  },
  {
    id: "5",
    name: "Хоразм",
    lat: "41.3565",
    lon: "60.8567",
    tumanlar: [
      { nomi: "Хива", lat: "41.382968", lon: "60.361550" },
      { nomi: "Боғот", lat: "41.325935", lon: "60.836552" },
      { nomi: "Гурлан", lat: "41.880465", lon: "60.354633" },
      { nomi: "Қўшкўпир", lat: "41.503981", lon: "60.261981" },
      { nomi: "Урганч", lat: "41.559730", lon: "60.631143" },
      { nomi: "Хонқа", lat: "41.486238", lon: "60.834450" },
      { nomi: "Хазорасп", lat: "41.284269", lon: "61.140964" },
      { nomi: "Шовот", lat: "41.691029", lon: "60.255234" },
      { nomi: "Янгиариқ", lat: "41.325265", lon: "60.585814" },
      { nomi: "Янгибозор", lat: "41.729620", lon: "60.489380" },
      { nomi: "Урганч тумани", lat: "41.603834", lon: "60.598660" },
      { nomi: "Тупроққалъа", lat: "41.205986", lon: "61.286042" },
    ],  },
  {
    id: "6",
    name: "Наманган",
    lat: "41.0058",
    lon: "71.6436",
    tumanlar: [
      { nomi: "Наманган", lat: "41.000085", lon: "71.672579" },
      { nomi: "Чуст", lat: "41.002399", lon: "71.226422" },
      { nomi: "Косонсой", lat: "41.182108", lon: "71.553220" },
      { nomi: "Мингбуллоқ", lat: "40.772558", lon: "71.366191" },
      { nomi: "Норин", lat: "40.934316", lon: "72.013768" },
      { nomi: "Поп", lat: "41.012198", lon: "70.780651" },
      { nomi: "Тўрақўрғон", lat: "40.956378", lon: "71.482522" },
      { nomi: "Уйчи", lat: "41.039077", lon: "71.920298" },
      { nomi: "Янгиқўрғон", lat: "41.187415", lon: "71.727610" },
      { nomi: "Учқўрғон", lat: "41.042797", lon: "72.111271" },
    ],  },
  {
    id: "7",
    name: "Навоий",
    lat: "40.0974",
    lon: "65.3525",
    tumanlar: [
      { nomi: "Навоий", lat: "40.103107", lon: "65.373996" },
      { nomi: "Конимех", lat: "41.058907", lon: "64.622457" },
      { nomi: "Кармана", lat: "40.038130", lon: "65.278461" },
      { nomi: "Қизилтепа", lat: "40.035485", lon: "64.847009" },
      { nomi: "Навбахор", lat: "40.258977", lon: "65.439654" },
      { nomi: "Нурота", lat: "40.564805", lon: "65.693006" },
      { nomi: "Томди", lat: "42.052267", lon: "65.243651" },
      { nomi: "Учқудуқ", lat: "42.152753", lon: "63.562499" },
      { nomi: "Зарафшон", lat: "41.568824", lon: "64.202665" },
      { nomi: "Хатирчи", lat: "40.191456", lon: "65.943645" },
    ],  },
  {
    id: "8",
    name: "Қашқадарё",
    lat: "38.9271",
    lon: "65.7539",
    tumanlar: [
      { nomi: "Қарши", lat: "38.841605", lon: "65.789979" },
      { nomi: "Чироқчи", lat: "39.215982", lon: "66.530515" },
      { nomi: "Деҳқонобод", lat: "38.367516", lon: "66.629823" },
      { nomi: "Ғузор", lat: "38.540298", lon: "66.146422" },
      { nomi: "Касби", lat: "38.893996", lon: "65.453686" },
      { nomi: "Китоб", lat: "39.191100", lon: "67.059793" },
      { nomi: "Косон", lat: "41.182108", lon: "71.553220" },
      { nomi: "Миришкор", lat: "38.819690", lon: "64.977902" },
      { nomi: "Муборак", lat: "39.294302", lon: "65.280545" },
      { nomi: "Нишон", lat: "38.519312", lon: "65.578031" },
      { nomi: "Қамаши", lat: "38.695593", lon: "66.795562" },
      { nomi: "Шахрисабз", lat: "39.060073", lon: "66.829474" },
      { nomi: "Яккабоғ", lat: "38.893343", lon: "66.825773" },
      { nomi: "Шахрисабз тумани", lat: "38.980256", lon: "67.140812" },
      { nomi: "Қарши тумани", lat: "38.781238", lon: "65.797013" },
      { nomi: "Кўкдала", lat: "39.172950", lon: "66.180504" },
    ],  },
  {
    id: "9",
    name: "Қорақалпоғистон",
    lat: "43.8041",
    lon: "59.4458",
    tumanlar: [
      { nomi: "Амударё", lat: "42.151624", lon: "60.140205" },
      { nomi: "Беруний", lat: "42.032071", lon: "60.843927" },
      { nomi: "Қораўзак", lat: "42.760365", lon: "60.157920" },
      { nomi: "Қўнғирот", lat: "43.531151", lon: "57.312560" },
      { nomi: "Нукус", lat: "42.460341", lon: "59.617996" },
      { nomi: "Тўрткўл", lat: "41.571313", lon: "61.413270" },
      { nomi: "Чимбой", lat: "43.102109", lon: "59.692781" },
      { nomi: "Элликқалъа", lat: "41.907782", lon: "61.026977" },
      { nomi: "Тахиатош", lat: "42.322428", lon: "59.512687" },
      { nomi: "Қонликўл", lat: "42.786029", lon: "59.083472" },
      { nomi: "Кегайли", lat: "42.740576", lon: "59.698414" },
      { nomi: "Мўйноқ", lat: "43.766605", lon: "59.028055" },
      { nomi: "Тахтакўприк", lat: "43.159008", lon: "61.186275" },
      { nomi: "Хўжайли", lat: "42.459876", lon: "59.369531" },
      { nomi: "Шўманой", lat: "42.662505", lon: "58.902884" },
      { nomi: "Нукус тумани", lat: "42.539086", lon: "59.585432" },
      { nomi: "Бўзатов", lat: "42.962202", lon: "59.350227" },
    ],  },              
  {
    id: "10",
    name: "Самарқанд",
    lat: "39.6508",
    lon: "66.9654",
    tumanlar: [
      { nomi: "Самарқанд", lat: "39.675906", lon: "66.959712" },
      { nomi: "Булунғур", lat: "39.711916", lon: "67.326979" },
      { nomi: "Жомбой", lat: "39.789827", lon: "67.085278" },
      { nomi: "Иштихон", lat: "40.021425", lon: "66.526490" },
      { nomi: "Каттақўрғон", lat: "40.046822", lon: "66.261478" },
      { nomi: "Қўшработ", lat: "40.379515", lon: "66.533389" },
      { nomi: "Нарпай", lat: "39.933116", lon: "65.982479" },
      { nomi: "Нуробод", lat: "39.631006", lon: "65.993636" },
      { nomi: "Оқдарё", lat: "39.837136", lon: "66.752398" },
      { nomi: "Паяриқ", lat: "40.016908", lon: "66.886589" },
      { nomi: "Пастдарғом", lat: "39.660431", lon: "66.662297" },
      { nomi: "Пахтачи", lat: "39.885257", lon: "65.569120" },
      { nomi: "Тайлоқ", lat: "39.570805", lon: "67.150172" },
      { nomi: "Каттақўрғон", lat: "40.046822", lon: "66.261478" },
      { nomi: "Ургут", lat: "39.405588", lon: "67.145501" },
    ],  },          
  {
    id: "11",
    name: "Сирдарё",
    lat: "40.8373",
    lon: "68.6618",
    tumanlar: [
      { nomi: "Сирдарё", lat: "40.838844", lon: "68.664229" },
      { nomi: "Гулистон", lat: "40.509489", lon: "68.769089" },
      { nomi: "Мирзаобод", lat: "40.451136", lon: "68.633875" },
      { nomi: "Оқолтин", lat: "40.533352", lon: "68.326193" },
      { nomi: "Сардоба", lat: "40.338235", lon: "68.308415" },
      { nomi: "Сайхунобод", lat: "40.657411", lon: "68.832052" },
      { nomi: "Ширин", lat: "40.230259", lon: "69.127661" },
      { nomi: "Ховос", lat: "40.230734", lon: "68.713843" },
      { nomi: "Янгиер", lat: "40.274089", lon: "68.813655" },
      { nomi: "Гулистон тумани", lat: "40.516668", lon: "68.914715" },
    ],  },
 {
    id: "12",
    name: "Сурхондарё",
    lat: "37.9409",
    lon: "67.5709",
    tumanlar: [
      { nomi: "Бойсун", lat: "38.128122", lon: "67.182431" },
      { nomi: "Денов", lat: "38.323682", lon: "67.820837" },
      { nomi: "Жарқўрғон", lat: "37.504300", lon: "67.464421" },
      { nomi: "Музработ", lat: "37.423107", lon: "66.864104" },
      { nomi: "Олтинсой", lat: "38.181924", lon: "67.733628" },
      { nomi: "Қизириқ", lat: "37.648587", lon: "67.245160" },
      { nomi: "Қумқўрғон", lat: "37.885939", lon: "67.582567" },
      { nomi: "Сариосиё", lat: "38.732662", lon: "67.801783" },
      { nomi: "Шеробод", lat: "37.728920", lon: "66.848725" },
      { nomi: "Шўрчи", lat: "37.954163", lon: "67.863641" },
      { nomi: "Термиз", lat: "37.228581", lon: "67.275451" },
      { nomi: "Бандихон", lat: "37.820381", lon: "67.359381" },
      { nomi: "Узун", lat: "38.168273", lon: "68.182696" },
    ],  },           
  {
    id: "13",
    name: "Тошкент",
    lat: "41.2995",
    lon: "69.2401",
    tumanlar: [
      { nomi: "Тошкент", lat: "41.311158", lon: "69.279737" },
      { nomi: "Бекобод", lat: "40.391034", lon: "69.200029" },
      { nomi: "Бўка", lat: "40.725945", lon: "69.191109" },
      { nomi: "Бўстонлиқ", lat: "41.571610", lon: "69.939352" },
      { nomi: "Чиноз", lat: "40.999343", lon: "68.825926" },
      { nomi: "Оққўрғон", lat: "40.819383", lon: "69.002966" },
      { nomi: "Оҳангарон", lat: "40.980318", lon: "69.867001" },
      { nomi: "Паркент", lat: "41.257878", lon: "69.751999" },
      { nomi: "Қуйи Чирчиқ", lat: "40.934418", lon: "68.997737" },
      { nomi: "Қибрай", lat: "41.428722", lon: "69.488361" },
      { nomi: "Янгийўл", lat: "41.128545", lon: "68.995968" },
      { nomi: "Зангиота", lat: "41.260515", lon: "69.085656" },
      { nomi: "Чирчиқ", lat: "41.461957", lon: "69.578714" },
      { nomi: "Пискент", lat: "40.898111", lon: "69.351162" },
      { nomi: "Юқори чирчиқ", lat: "41.169585", lon: "69.545234" },
      { nomi: "Нурафшон", lat: "41.042695", lon: "69.357477" },
      { nomi: "Ангрен", lat: "41.020472", lon: "70.110202" },
      { nomi: "Бекобод", lat: "40.391034", lon: "69.200029" },
      { nomi: "Олмалиқ", lat: "40.852003", lon: "69.568752" },
      { nomi: "Янгийўл", lat: "41.128545", lon: "68.995968" },
    ],  },     
];

export default viloyatlar;